import axios from "axios";
import { toast } from "react-toastify";

const userVerification = {
  verify: async (email) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/auth/request-activate-token`,
        { email }
      );

      if (response?.data?.status) {

        toast.success("Verification email sent successfully! Please check your inbox.");
      }
    } catch (error) {
      // ❗️ Show error toast if request fails
      toast.error(
        error?.response?.data?.message || "Something went wrong! Please try again."
      );
    }
  },
};

export default userVerification;
